import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDevices: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDevices"><Path d="M14.5 8.5H22.5V21.5H14.5V8.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 19.5H19.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 8.5V3.5H3.5V17.5H2V20.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 17.5H14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconDevices;
